import { render, staticRenderFns } from "./banklist.vue?vue&type=template&id=3a7ef700&scoped=true"
import script from "./banklist.vue?vue&type=script&lang=ts"
export * from "./banklist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ef700",
  null
  
)

export default component.exports